import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { IconTool } from '@avantstay/backoffice-vectors'

import { mountRouteUrl, ROUTES } from '@routes'

import { GuestInboxCase } from '../../StayTimeline.types'
import { getEventWhen } from '../../StayTimeline.utils'
import * as S from './CaseOpenedCard.styles'

interface CaseOpenedCardProps {
  caseItem: GuestInboxCase
  checkIn?: IDate | null
  checkout?: IDate | null
}

const HOT_PRIORITIES = ['URGENT', 'HIGH']

export const CaseOpenedCard = ({ caseItem, checkIn, checkout }: CaseOpenedCardProps) => {
  const priority = (caseItem.priority ?? '').toUpperCase()
  const tone: S.CaseTone = HOT_PRIORITIES.includes(priority) ? 'hot' : 'warm'
  const opener = caseItem.openedByAutomation ? 'automation' : caseItem.openedBy

  return (
    <S.Root $tone={tone}>
      <S.Head>
        <S.Glyph $tone={tone}>
          <IconTool />
        </S.Glyph>
        <S.Label $tone={tone}>CASE OPENED{priority ? ` · ${priority}` : ''}</S.Label>
        <S.Spacer />
        <S.Link
          href={mountRouteUrl(ROUTES.operationCases.path, undefined, { case: caseItem.caseId })}
          target="_blank"
          rel="noopener"
        >
          Open case ↗
        </S.Link>
      </S.Head>

      <S.Subject>{caseItem.subject || caseItem.categoryLabel}</S.Subject>

      <S.Meta>
        {opener ? `${opener} · ` : ''}
        {caseItem.status || 'open'} · {getEventWhen(caseItem.openedAt, checkIn, checkout)}
      </S.Meta>
    </S.Root>
  )
}
